<button
  mat-icon-button
  class="options-menu-btn"
  [hidden]="mode.inNodeConnectionMode"
  (click)="openMenu($event)"
>
  <svg-icon
    src="assets/svg/flows/options.svg"
    [ngClass]="{ 'menu-open': selected, error: touched && !conditionsValid }"
    svgClass="{{
      !selected && touched && !conditionsValid ? 'matWarn' : 'veryLightGrey'
    }}"
  ></svg-icon>
</button>
